import { AxiosResponse } from "axios";

export default (res: AxiosResponse<BlobPart>) => {
  const { headers, data } = res;
  // Get File name from headers
  const fileName: string = headers["content-disposition"].split("filename=")[1].replace(/"/g, "");
  const secondFileName: string = headers["content-disposition"].split("filename*=utf-8''")[1]?.replace(/"/g, ""); // resolve issue with Hebrew characters
  const utf8FileName = secondFileName && decodeURIComponent(secondFileName);

  // Create link for download
  const link = document.createElement("a");
  // Set correct file name for future download
  link.setAttribute("download", `${utf8FileName ? utf8FileName : fileName}`);
  // Create URL for download from Blob
  const url: string = URL.createObjectURL(new Blob([data]));
  // Set URL to link
  link.href = url;
  // Start downloading
  link.click();
  // Delete inner link => clear memory
  URL.revokeObjectURL(link.href);
};
